import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import { Action } from '../../../config/interfaces';
import { USERLOGINFETCH } from '../config';
import { UserAPI } from '../config';
import {
  userLoginSuccess,
  userLoginFailed,
} from './ActionAuth';
import { HttpService } from '../../../utilities';
// import * as CryptoJS from 'crypto-js';
// import { LDAP_SERVICE_BASIC_AUTH_PASSWORD, LDAP_SERVICE_BASIC_AUTH_USER, LDAP_SERVICE_HOST, LDAP_SERVICE_PROTOCOL } from '../../../config';



function* workerSagaLogin(params: Action): any {
  try {
    const data: object = {
      Email: params.data.Email,
      Password: params.data.Password,
      Redirect: params.data.Redirect
    };
    const headers: object = {
      'Login-Token': '',
    };
    // const BasicAuth = CryptoJS.enc.Utf8.parse(`${LDAP_SERVICE_BASIC_AUTH_USER}:${LDAP_SERVICE_BASIC_AUTH_PASSWORD}`);
    //   const headers = {
    //     Authorization: `Basic ${CryptoJS.enc.Base64.stringify(BasicAuth)}`,
    //     'Login-Token': '',
    //     'Content-Type': 'application/json',
    //   };
    // const response = yield call(HttpService.post, `${LDAP_SERVICE_PROTOCOL}://${LDAP_SERVICE_HOST}/lintas-api-login-dev`, data, headers);
    // const response = HttpService.post(`${LDAP_SERVICE_PROTOCOL}://${LDAP_SERVICE_HOST}/lintas-api-login-dev`, data, headers);
    const response = yield call(HttpService.post, UserAPI.login.api, data, headers);

    // console.log(response)
    // if (!response.data) throw(response);
    // if (response.status === 200 && response.data) {
    //   let msg = response.data;

    //   const parseResponse = {
    //     ...msg,
    //     token: msg.Token,
    //     // token_expired: response.headers.exp,
    //   };

    //   yield put(userLoginSuccess(parseResponse));
    if (!response.data) throw(response);
    if (response.data.statusCode === 200 && response.data.message.IsAuthorized) {
      const parseResponse = {
        ...response.data.message,
        token: response.data.message.Token,
      };

      yield put(userLoginSuccess(parseResponse));
    } else {
      yield put(userLoginFailed(response.data.message));
    }
  } catch (error: any) {
    yield put(userLoginFailed(error.message));
  }
}

export const watcherSagaLogin = [
  takeLatest(USERLOGINFETCH, workerSagaLogin),
];
